import type { VariantInfo, Campaign } from '~/modules/campaign/types';
import type { ICGTemplateVariantProperty } from '../types';

import { CGTemplatePairVariantColumn } from './CGTemplatePairVariantColumn';
import { useGTableContext, GTable } from '~/presentation/ui';
import { Box } from '@shopify/polaris';
import { useMemo } from 'react';

export interface CGTemplatePairVariantsProps {
  campaign: Campaign;
  variants: VariantInfo[];
}
export const CGTemplatePairVariants: React.FC<CGTemplatePairVariantsProps> = ({
  campaign,
  variants,
}) => {
  const { listHeader, parsePaddingRow } = useGTableContext();
  const propertiesToDisplay = useMemo(
    () => listHeader.map((header) => header.id as ICGTemplateVariantProperty),
    [listHeader],
  );

  return (
    <Box borderRadius="300" background="bg-fill-active" padding="0">
      <GTable.Row>
        {propertiesToDisplay.map((property, columnIndex) => (
          <CGTemplatePairVariantColumn
            key={`property-${property}`}
            campaign={campaign}
            variants={variants}
            property={property}
            columnIndex={columnIndex}
            parsePaddingRow={parsePaddingRow}
          />
        ))}
      </GTable.Row>
    </Box>
  );
};
